import { styled } from '@mui/system';

export const TextElement = styled('span')({
    fontFamily: 'inherit',
    fontSize: 'inherit',
    whiteSpace: 'nowrap',
    fontStyle: 'italic',
});

export const FormulaContainer = styled('div')({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.5rem',
    fontSize: '14px',
    fontFamily: 'serif',
    margin: '1rem 0',
    flexWrap: 'wrap',
    lineHeight: '1.4',
    color: 'black',
});

export const FractionContainer = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '0 0.5rem',
    margin: '0 0.25rem',
    minHeight: '2.5em',
    justifyContent: 'center',
    position: 'relative',
});

export const Numerator = styled('div')({
    borderBottom: '1px solid #000',
    padding: '0.25rem 0',
    textAlign: 'center',
    minWidth: 'max-content',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
});

export const Denominator = styled('div')({
    padding: '0.25rem 0',
    textAlign: 'center',
    minWidth: 'max-content',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
});

export const Operator = styled('span')({
    margin: '0 0.25rem',
    fontWeight: 'bold',
    fontSize: '16px',
});

export const Parentheses = styled('span')({
    fontSize: '18px',
    fontWeight: 'bold',
    margin: '0 0.1rem',
});
